import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { StackTaskRun } from "shared/Stack/useSearchTasks/gql";

import { STACK_TASKS_COLUMN_ID } from "../constants";
import StackTasksTableActionsCell from "./ActionsCell";
import StackTasksTableCommandCell from "./CommandCell";
import StackTasksTableCommitCell from "./CommitCell";
import StackTasksTableStartedAtCell from "./StartedAtCell";
import StackTasksTableStatusCell from "./StatusCell";
import StackTasksTableTriggeredByCell from "./TriggeredByCell";

export const STACK_TASKS_TABLE_CELLS: TableCellPerColumn<StackTaskRun> = {
  [STACK_TASKS_COLUMN_ID.STATUS]: StackTasksTableStatusCell,
  [STACK_TASKS_COLUMN_ID.COMMAND]: StackTasksTableCommandCell,
  [STACK_TASKS_COLUMN_ID.TRIGGERED_BY]: StackTasksTableTriggeredByCell,
  [STACK_TASKS_COLUMN_ID.COMMIT]: StackTasksTableCommitCell,
  [STACK_TASKS_COLUMN_ID.STARTED_AT]: StackTasksTableStartedAtCell,
  [STACK_TASKS_COLUMN_ID.ROW_ACTIONS]: StackTasksTableActionsCell,
};
